var map = {
	"./1stplace.svg": 127,
	"./2ndplace.svg": 128,
	"./3rdplace.svg": 129,
	"./Buoy.svg": 179,
	"./City blue.svg": 180,
	"./City orange.svg": 181,
	"./Close-x.svg": 173,
	"./Cloud.svg": 8,
	"./Coalplant - sea.svg": 182,
	"./Coalplant.svg": 183,
	"./Company blue.svg": 184,
	"./Company orange.svg": 185,
	"./Decentral solar.svg": 186,
	"./Decentral wind.svg": 187,
	"./EnecoGroep logo.svg": 57,
	"./Gasplant - sea.svg": 188,
	"./Gasplant.svg": 189,
	"./Government.svg": 190,
	"./Icon -  small central sm.svg": 166,
	"./Icon -  smart appliances.svg": 42,
	"./Icon - Smart network - inline.svg": 191,
	"./Icon - Smart network.svg": 29,
	"./Icon - add decentral.svg": 27,
	"./Icon - add source.svg": 70,
	"./Icon - battery.svg": 164,
	"./Icon - deal.svg": 17,
	"./Icon - destroy.svg": 69,
	"./Icon - employees.svg": 161,
	"./Icon - fluctuation.svg": 162,
	"./Icon - funds.svg": 157,
	"./Icon - gasplant   .svg": 71,
	"./Icon - gasplant sm.svg": 170,
	"./Icon - green power.svg": 159,
	"./Icon - necessity.svg": 163,
	"./Icon - network hud.svg": 30,
	"./Icon - network-on.svg": 192,
	"./Icon - network.svg": 31,
	"./Icon - powerplant sm.svg": 169,
	"./Icon - powerplant.svg": 72,
	"./Icon - production power +.svg": 158,
	"./Icon - residents.svg": 160,
	"./Icon - smart appliciances sm.svg": 165,
	"./Icon - smart distributors.svg": 43,
	"./Icon - smart lighting .svg": 44,
	"./Icon - solarpower sm.svg": 168,
	"./Icon - solarpower.svg": 193,
	"./Icon - storage.svg": 45,
	"./Icon - warning.svg": 194,
	"./Icon - windfarm sm.svg": 167,
	"./Icon - windfarm.svg": 73,
	"./Icon-skip.svg": 74,
	"./Icon-stop.svg": 75,
	"./Island0.svg": 41,
	"./Island25.svg": 76,
	"./Island50.svg": 77,
	"./Island75.svg": 78,
	"./Lighthouse beams.svg": 79,
	"./Lighthouse.svg": 80,
	"./Market.svg": 195,
	"./Plot-internal.svg": 28,
	"./Plot.svg": 32,
	"./Road segment back.svg": 196,
	"./Road segment front.svg": 171,
	"./Road turn left.svg": 197,
	"./Road turn right.svg": 198,
	"./Solarfarm - sea.svg": 199,
	"./Solarfarm.svg": 200,
	"./Supplier.svg": 201,
	"./Windfarm - internal.svg": 202,
	"./Windfarm.svg": 203,
	"./dropdown.svg": 174,
	"./minus.svg": 131,
	"./page footer scenery 2.svg": 55,
	"./page footer scenery.svg": 39,
	"./page header scenery 2.svg": 54,
	"./page header scenery 3.svg": 56,
	"./page header scenery.svg": 38,
	"./plus.svg": 130,
	"./road - complete.svg": 172,
	"./spinner.svg": 81,
	"./waves.svg": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements ^\.\/.*\.svg$
// module id = 20
// module chunks = 0